import React from 'react';
import { StyledNavLoginLink } from './style/NavLoginLink.styled';
import { LoginLink } from '../..';

export const NavLoginLink = () => {
    return (
        <StyledNavLoginLink>
            <LoginLink />
        </StyledNavLoginLink>
    );
};
